import { render, staticRenderFns } from "./ConsolidateLoadsModal.vue?vue&type=template&id=58d19def"
import script from "./ConsolidateLoadsModal.vue?vue&type=script&lang=ts"
export * from "./ConsolidateLoadsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports